import fetch from 'auth/FetchInterceptor'

const GroupService = {}

GroupService.getGroupList = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Group/GetGroups',
        method: 'get',
        params,
    })
}

GroupService.getGroupsToExcel = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Group/GetAllGroupsExcel',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

GroupService.addGroup = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Group',
        method: 'post',
        data: data,
    })
}

GroupService.getGroupDetail = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Group/GetGroup/${params}`,
        method: 'get',
    })
}

GroupService.deleteGroup = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Group/${encodeURIComponent(params)}`,
        method: 'delete',
        params,
    })
}

GroupService.updateGroup = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Group',
        method: 'put',
        data: data,
    })
}

GroupService.getGroupChargePoints = function (groupId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/ChargePointGroup/GetChargePointsByGroupId',
        method: 'get',
        params: { groupId: groupId },
    })
}

GroupService.updateGroupChargePoints = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/ChargePointGroup',
        method: 'put',
        data: data,
    })
}

GroupService.removeCommand = function (commandId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Command/RemoveCommand/${commandId}`,
        method: 'delete',
    })
}

GroupService.retryCommand = function (commandDetailId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'ocpp/RemoteTrigger/retryCommand',
        method: 'post',
        data: { commandDetailId },
    })
}

GroupService.retryCommandAll = function (commandId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'ocpp/RemoteTrigger/retryCommandAll',
        method: 'post',
        data: { commandId },
    })
}

GroupService.archiveCommand = function (commandId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Command/archiveCommand/${commandId}`,
        method: 'put',
    })
}

GroupService.unarchiveCommand = function (commandId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Command/UnarchiveCommand/${commandId}`,
        method: 'put',
    })
}

GroupService.getActiveCommands = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Command/GetCommandsWithDetails',
        method: 'get',
        params,
    })
}

GroupService.getArchivedCommands = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Command/GetCommandsWithDetailsArchived',
        method: 'get',
        params,
    })
}

export default GroupService
